import { render, staticRenderFns } from "./ConsentField.vue?vue&type=template&id=9f1b213a&"
import script from "./ConsentField.vue?vue&type=script&lang=js&"
export * from "./ConsentField.vue?vue&type=script&lang=js&"
import style0 from "./ConsentField.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
